<div class="header-tbk d-flex ">
    <div class="d-flex justify-content-start header-logo">
        <a href="https://publico.transbank.cl/">
            <img class="logo-tbk" src="https://publico.transbank.cl/documents/121605/0/logo.png" alt="Logo Transbank" title="Ir a sitio publico">
        </a>
        <div class="barra-logo" id="barra-logo-header "></div>
    </div>
    <ng-container *ngIf="!retoma">
        <div class="ml-auto notificaciones">
            <div (click)="toggleCarro()" *ngIf="(productos$ | async) as productos" class="circulo-notificaciones disp">
                <div class="c-notificaciones">{{productos.length}}</div>
            </div>
            <img (click)="toggleCarro() " src="assets/icons/car.svg" class="ico-carro mr-20" alt="cart icon">
        </div>
    </ng-container>
    <ng-container *ngIf="ejecutivo != null">
        <div [ngClass]="{'ml-auto':retoma}" class="mr-2 user-box">
            <ngx-avatar name="{{ejecutivo.nombre}}" 
            matTooltip="{{ejecutivo.nombre}} - {{ejecutivo.email}}" 
            [matTooltipPosition]="'before'"></ngx-avatar>
            <div class="user-info">
                <div class="name">{{ejecutivo.nombre}}</div>
                <div class="email">{{ejecutivo.email}}</div>
            </div>
        </div>
    </ng-container>
    
</div>